const key = "global";
export default key;
